<!--
 * @Description: file content
 * @Author: liujunyao
 * @Date: 2022-04-22 11:44:44
 * @LastEditors: liujunyao
 * @LastEditTime: 2022-04-22 14:00:26
 * @FilePath: /privacy-web/src/components/PrivacyProtect/ManageProcessContentItem.vue
-->
<template>
  <div
    class="Manage-process-content-item-main"
    :class="{ 'Manage-process-content-item-main-mobile': isMobile }"
  >
    <div class="title">{{ data.title }}</div>
    <div v-for="item in data.content" :key="item" class="contents">
      {{ item }}
    </div>
  </div>
</template>
<script>
export default {
  name: "ManageProcessContentItem",
  props: {
    data: {
      type: Object,
      default: () => {},
    },
  },
};
</script>
<style lang="scss" scoped>
.Manage-process-content-item-main {
  width: calc($multiple * 379px);
  height: calc($multiple * 415px);
  background: url("~assets/images/privacyProtect/process-bg1.png") no-repeat;
  background-size: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.title {
  width: calc($multiple * 349px);
  height: calc($multiple * 120px);
  font-size: calc($multiple * 18px);
  font-family: AlibabaPuHuiTi_2_75_SemiBold;
  color: #000000;
  line-height: calc($multiple * 25px);
  background: #EDF5FF;
  border-radius: 8px 8px 0px 0px;
  text-align: center;
  position: relative;
  padding-top: calc($multiple * 73px);
  margin-bottom: calc($multiple * 34px);
}
.title::after {
  content: "";
  position: absolute;
  bottom: calc($multiple * -6px);
  left: 50%;
  transform: translate(-50%);
  width: calc($multiple * 83px);
  height: calc($multiple * 6px);
  background: #0072f5;
  border-radius: 3px;
}
.contents {
  font-size: calc($multiple * 14px);
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(0, 0, 0, 0.6);
  line-height: calc($multiple * 36px);
}
.Manage-process-content-item-main-mobile {
  width: 18.59rem;
  max-height: 13rem;
  /* min-height: 10rem; */
  background: url("~assets/images/privacyProtect/process-bg1.png") no-repeat;
  background-size: cover;
  background-position-y: bottom;
  margin-top: -1.5rem;
  .title {
    font-size: 0.82rem;
    height: 3.5rem;
    background: #EDF5FF;
    font-family: PingFangSC-Medium, PingFang SC;
    line-height: 1.13rem;
    padding-top: 1.4rem;
    margin-bottom: 1rem;
    position: relative;
  }
  .title::after {
    content: "";
    position: absolute;
    bottom: -0.18rem;
    left: 50%;
    transform: translate(-50%);
    width: 3.69rem;
    height: 0.18rem;
    border-radius: 0.15rem;
  }
  .contents {
    font-size: 0.61rem;
    line-height: 0.98rem;
    letter-spacing: 0.05rem;
  }
}
</style>
